import { Klydo, KlydoTimes, timeTypes } from "Types";
import { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteIcon from "@mui/icons-material/Delete";
import firebaseService from "firebase_service/firebaseService";
import { percentToPresent, WeekEnum } from "../../utils/util";
import { calcTimes } from "./TimeCalc";
import DSBox from "../../views/system-design/DSBox";
import DSTypography from "../../views/system-design/DSTypography";
import DSDialog from "../../views/system-design/DSDialog";
import DSDialogTitle from "../../views/system-design/DSDialogTitle";
import DSDialogContent from "../../views/system-design/DSDialogContent";
import DSDialogActions from "../../views/system-design/DSDialogActions";
import DSTextField from "../../views/system-design/DSTextField";
import DSMenuItem from "../../views/system-design/DSMenuItem";
import DSCheckBox from "../../views/system-design/DSCheckBox";
import DSFormControlLabel from "../../views/system-design/DSFormControlLabel";
import DSPrimaryButton from "../../views/system-design/DSPrimaryButton";
import DSSecondaryButton from "../../views/system-design/DSSecondaryButton";
import DSCircularProgress from "../../views/system-design/DSCircularProgress";
import useDeviceType from "components/hooks/useDeviceType";

const tTypes = ["daily", "weekly", "monthly", "yearly"];
const weekDays = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

const TimeControl = (props: {
  klydo: Klydo;
  editable?: boolean;
  isReview?: boolean;
}) => {
  const { isSmallTablet } = useDeviceType();
  const [times, setTimes] = useState(
    props.klydo?.times ?? ([] as KlydoTimes[]),
  );
  const [editTimes, setEditTimes] = useState([] as KlydoTimes[]);
  const [warnings, setWarnings] = useState<Array<string>>([]);
  const [globalWarning, setGlobalWarning] = useState("");
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);

  const closeModal = () => {
    setEditTimes([]);
    setModal(false);
  };
  const checkGlobalWarning = (): boolean => {
    let type = undefined as timeTypes | undefined;
    let res = true;
    editTimes.forEach((t) => {
      if (!!!type) {
        if (t.type !== "daily") type = t.type;
      } else {
        if (t.type !== "daily" && t.type !== type) {
          res = false;
        }
      }
    });
    res
      ? setGlobalWarning("")
      : setGlobalWarning("Only one type of date is permitted");
    return res;
  };
  const resetTypeInput = (i: number, type: timeTypes) => {
    switch (type) {
      case "daily": {
        editTimes[i].start = "00:00";
        editTimes[i].end = "23:59";
        break;
      }
      case "weekly": {
        editTimes[i].start = "sunday";
        editTimes[i].end = "saturday";
        break;
      }
      case "monthly": {
        editTimes[i].start = "1";
        editTimes[i].end = "31";
        break;
      }
      case "yearly": {
        editTimes[i].start = "01/01";
        editTimes[i].end = "31/12";
        break;
      }
    }
    setEditTimes([...editTimes]);
  };
  const dateChek = (s: string): string => {
    const chk = s.split("/");
    if (chk.length !== 2) return "Date format is dd/mm";
    if (chk[0].length === 0 || chk[1].length === 0) return "Incomplete date";
    if (
      !(
        /^(([0-2]?[0-9])|(3[0-1]))$/.test(chk[0]) &&
        /^((0?[0-9])|(1[0-2]))$/.test(chk[1])
      )
    )
      return "Incorect Date";
    if (
      (chk[0] === "30" && /^0?2$/.test(chk[1])) ||
      (chk[0] === "31" && /^(0?[2469]|11)$/.test(chk[1]))
    )
      return "Date do not exist";
    return "";
  };
  const inputBoxSx = {
    width: { xxs: "100%", md: "500px" },
    marginLeft: "12px",
    marginRight: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
  };
  const inputType = (i: number) => {
    switch (editTimes[i].type) {
      case "daily":
        return (
          <DSBox sx={inputBoxSx}>
            <DSTypography>start time:</DSTypography>
            <DSTextField
              size="small"
              sx={{ width: "140px" }}
              value={editTimes[i].start}
              onChange={(e) => {
                editTimes[i].start = e.target.value;
                setEditTimes([...editTimes]);
              }}
              type="time"
            />
            <DSTypography>end time:</DSTypography>
            <DSTextField
              size="small"
              sx={{ width: "140px" }}
              value={editTimes[i].end}
              onChange={(e) => {
                editTimes[i].end = e.target.value;
                setEditTimes([...editTimes]);
              }}
              type="time"
            />
          </DSBox>
        );
      case "weekly":
        return (
          <DSBox sx={inputBoxSx}>
            <DSTypography>start day:</DSTypography>
            <DSTextField
              select
              size="small"
              sx={{ width: "140px" }}
              value={editTimes[i].start}
              onChange={(e) => {
                editTimes[i].start = e.target.value;
                setEditTimes([...editTimes]);
              }}
            >
              {weekDays.map((t, i) => (
                <DSMenuItem key={i} value={t}>
                  {t}
                </DSMenuItem>
              ))}
            </DSTextField>
            <DSTypography>end day:</DSTypography>
            <DSTextField
              select
              size="small"
              sx={{ width: "140px" }}
              value={editTimes[i].end}
              onChange={(e) => {
                editTimes[i].end = e.target.value as string;
                setEditTimes([...editTimes]);
              }}
            >
              {weekDays.map((t, i) => (
                <DSMenuItem key={i} value={t}>
                  {t}
                </DSMenuItem>
              ))}
            </DSTextField>
          </DSBox>
        );
      case "monthly":
        return (
          <DSBox sx={inputBoxSx}>
            <DSTypography>start day:</DSTypography>
            <DSTextField
              size="small"
              sx={{ width: "140px" }}
              value={editTimes[i].start}
              onChange={(e) => {
                editTimes[i].start = e.target.value;
                setEditTimes([...editTimes]);
              }}
              type="number"
              inputProps={{ max: 31, min: 1 }}
            />
            <DSTypography>end day:</DSTypography>
            <DSTextField
              size="small"
              sx={{ width: "140px" }}
              value={editTimes[i].end}
              onChange={(e) => {
                editTimes[i].end = e.target.value;
                setEditTimes([...editTimes]);
              }}
              type="number"
              inputProps={{ max: 31, min: 1 }}
            />
          </DSBox>
        );
      case "yearly":
        return (
          <DSBox sx={inputBoxSx}>
            <DSTypography>start date:</DSTypography>
            <DSTextField
              size="small"
              sx={{ width: "140px" }}
              value={editTimes[i].start}
              onChange={(e) => {
                const w = dateChek(e.target.value);
                if (w === "" || w === "Incomplete date") {
                  editTimes[i].start = e.target.value;
                  setEditTimes([...editTimes]);
                }
              }}
            />
            <DSTypography>end date:</DSTypography>
            <DSTextField
              size="small"
              sx={{ width: "140px" }}
              value={editTimes[i].end}
              onChange={(e) => {
                const w = dateChek(e.target.value);
                if (
                  w === "" ||
                  w === "Incomplete date" ||
                  w === "Date format is dd/mm"
                ) {
                  editTimes[i].end = e.target.value;
                  setEditTimes([...editTimes]);
                }
              }}
            />
          </DSBox>
        );
    }
  };
  const checkWarnings = (): boolean => {
    let res = true;
    const typwarn = !checkGlobalWarning();
    const warnArr = Array<string>(editTimes.length);
    const inOrderDaily = (s: string, e: string): boolean => {
      const st = s.split(":");
      const et = e.split(":");
      return !(
        parseInt(st[0]) > parseInt(et[0]) ||
        (parseInt(st[0]) === parseInt(et[0]) &&
          parseInt(st[1]) > parseInt(et[1]))
      );
    };
    const inOrderYearly = (s: string, e: string): boolean => {
      const st = s.split("/");
      const et = e.split("/");
      return !(
        parseInt(st[1]) > parseInt(et[1]) ||
        (parseInt(st[1]) === parseInt(et[1]) &&
          parseInt(st[0]) > parseInt(et[0]))
      );
    };
    editTimes.forEach((t, i) => {
      let warn = "";
      if (typwarn && t.type !== "daily") {
        warn = "Only one type of date is permitted";
      } else {
        switch (t.type) {
          case "daily": {
            if (!inOrderDaily(t.start, t.end)) warn = "Wrong order";
            break;
          }
          case "yearly": {
            warn = dateChek(t.start) || dateChek(t.end);
            if (warn !== "") break;
            if (!inOrderYearly(t.start, t.end)) warn = "Wrong order";
            break;
          }
          case "monthly": {
            const start = parseInt(t.start);
            const end = parseInt(t.end);
            if (Number.isNaN(start) || Number.isNaN(end)) {
              warn = "Incorect input - must be a number";
            } else if (start > end) warn = "Wrong order";
            else if (start < 1 || start > 31 || end < 1 || end > 31)
              warn = "Incorect input - a number between 1 to 31";
            break;
          }
          case "weekly": {
            if (
              WeekEnum[t.start.toUpperCase() as any] >
              WeekEnum[t.end.toUpperCase() as any]
            )
              warn = "Wrong order";
            break;
          }
        }
      }
      if (warn !== "") res = false;
      warnArr[i] = warn;
    });
    setWarnings([...warnArr]);
    return res;
  };

  return (
    <>
      <DSBox sx={{ marginBottom: "14px" }}>
        <DSBox sx={{ display: "flex", flexDirection: "row" }}>
          <DSTypography sx={{ fontWeight: 700 }}>Best fit at:</DSTypography>
          {props.editable && (
            <EditIcon
              sx={{ fontSize: 20, marginLeft: "10px", cursor: "pointer" }}
              onClick={() => {
                setEditTimes(JSON.parse(JSON.stringify(times)));
                setModal(true);
              }}
            />
          )}
        </DSBox>
        {times?.length > 0 ? (
          <>
            {times.map((t, i) => (
              <DSBox key={i} sx={{ display: "flex", alignItems: "center" }}>
                <DSTypography
                  sx={{
                    margin: 0,
                    paddingLeft: t.negative ? "2px" : 0,
                    paddingRight: t.negative ? "10px" : "8px",
                  }}
                >
                  {t.negative ? "-" : "+"}
                </DSTypography>
                <DSTypography sx={{ margin: 0 }}>
                  type: {t.type}, from: {t.start} to: {t.end}
                </DSTypography>
              </DSBox>
            ))}
          </>
        ) : (
          <DSTypography sx={{ margin: 0 }}>all year round</DSTypography>
        )}
        <DSTypography>
          Available {percentToPresent(calcTimes(times))} of the year
        </DSTypography>
      </DSBox>
      <DSDialog
        open={modal}
        onClose={closeModal}
        maxWidth="lg"
        fullWidth
        fullScreen={isSmallTablet}
      >
        <DSDialogTitle>Define times this klydo best fit</DSDialogTitle>
        <DSDialogContent>
          {globalWarning && (
            <DSBox sx={{ color: "error.main" }}>{globalWarning}</DSBox>
          )}
          {editTimes?.map((t, i) => (
            <>
              <DSBox
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1,
                  marginTop: "12px",
                }}
              >
                {t.negative ? (
                  <RemoveIcon sx={{ fontSize: 24 }} />
                ) : (
                  <AddIcon sx={{ fontSize: 24 }} />
                )}
                <DSTextField
                  select
                  size="small"
                  value={editTimes[i].type}
                  sx={{ width: 150 }}
                  onChange={(e) => {
                    if (editTimes[i].type !== e.target.value) {
                      checkGlobalWarning();
                      resetTypeInput(i, e.target.value as timeTypes);
                      editTimes[i].type = e.target.value as timeTypes;
                    }
                    setEditTimes([...editTimes]);
                  }}
                >
                  {tTypes.map((t, i) => (
                    <DSMenuItem key={i} value={t}>
                      {t}
                    </DSMenuItem>
                  ))}
                </DSTextField>
                {inputType(i)}
                <DSBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyItems: "center",
                  }}
                >
                  <DSFormControlLabel
                    control={
                      <DSCheckBox
                        checked={editTimes[i].negative}
                        onChange={() => {
                          editTimes[i].negative = !editTimes[i].negative;
                          setEditTimes([...editTimes]);
                        }}
                      />
                    }
                    label={
                      <DSTypography sx={{ fontWeight: 700 }}>
                        Do not show in this time
                      </DSTypography>
                    }
                  />
                </DSBox>
                <DeleteIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    editTimes.splice(i, 1);
                    setEditTimes([...editTimes]);
                  }}
                />
              </DSBox>
              <DSTypography
                sx={{
                  marginLeft: { xxs: 0, md: "226px" },
                  color: "error.main",
                }}
              >
                {warnings[i] ?? ""}
              </DSTypography>
            </>
          ))}
          <DSPrimaryButton
            onClick={() => {
              editTimes.push({
                type: "daily",
                start: "00:00",
                end: "23:59",
                negative: false,
              });
              setEditTimes([...editTimes]);
            }}
          >
            Add time or date
          </DSPrimaryButton>
        </DSDialogContent>
        <DSDialogActions>
          <DSSecondaryButton onClick={closeModal}>Cancel</DSSecondaryButton>
          <DSPrimaryButton
            disabled={saving}
            onClick={() => {
              if (checkWarnings()) {
                setSaving(true);
                props.klydo.times = editTimes;
                firebaseService
                  .updateKlydoTimes(
                    props.klydo,
                    editTimes,
                    props.isReview ?? false,
                  )
                  .then(() => {
                    setTimes(JSON.parse(JSON.stringify(editTimes)));
                    closeModal();
                  })
                  .catch((e) =>
                    setGlobalWarning("Saving error:" + e.toString()),
                  )
                  .finally(() => setSaving(false));
              }
            }}
          >
            <DSBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {saving && <DSCircularProgress size={20} color="inherit" />}
              Save
            </DSBox>
          </DSPrimaryButton>
        </DSDialogActions>
      </DSDialog>
    </>
  );
};

export default TimeControl;
